<template>
  <section>
    <div id="contact" class="pd70">
      <div class="wrapper w1100">
        <BlockContactBox />
        <BlockContactForm />
        <span class="clr"></span>
      </div>
    </div>
  </section>
</template>